import { FC } from 'react'
import {getBookingFlowStepNum} from "../../lib/booking";

interface Props {
    content: ContentPage,
    booking: Booking
}

const Content: FC<Props> = ({ content,booking }) => {
    const num = getBookingFlowStepNum(booking);
    let heading = content.title;
    if(num)
        heading = num + '. ' + content.title;

    return (
        <div className="text-content">
            <h2>{heading}</h2>
            <div dangerouslySetInnerHTML={ content.content } />
        </div>
    )
}

export default Content
